// extracted by mini-css-extract-plugin
export default {"dotContainer":"Dot_dotContainer__pS1I8","player":"Dot_player__JFWnn"};